import React, { useEffect } from "react";

import "./style.scss";
import emptyUserImg from "../../assets/images/empty-user.png";
import authStore from "../../stores/authStore";
import globalStore from "../../global/globalStore";
import { isMobile } from "../../utils/tools";
import { wxLogin } from "../../utils/wx_tools";
import arrRightImg from "../../assets/images/arrow@2x.png";

interface Props {
  style?: React.CSSProperties;
}

const Nav = (props: Props) => {
  const { style = {} } = props;

  const { setDialog } = globalStore();
  const { userInfo, logout } = authStore();

  useEffect(() => {}, []);

  return (
    <div style={style} className="good_use-nav">
      <div className="nav__content">
        <div className="nav__left">
          <img
            className="nav__logo"
            src={window._config.assets.logo}
            alt="logo"
          />
          {/* <div
            className="nav_item"
            onClick={() => window.openNew("https://www.jiqizhixin.com")}
          >
            <img src={arrRightImg} alt="jiqizhixin" />
            机器之心
          </div> */}
        </div>
        <div className="nav__handle">
          {userInfo.id ? (
            <div className="nav__area">
              <div className="nav__user">
                <img src={userInfo.avatar} alt="avatar" />
              </div>
              {userInfo.name && (
                <div className="nav__name">{userInfo.name}</div>
              )}
              <div
                className="logout__btn"
                onClick={() => {
                  logout();
                }}
              >
                退出
              </div>
            </div>
          ) : (
              isMobile()
                ? window._config.var.hideMobileLoginEntry
                : window._config.var.hideLoginEntry
            ) ? (
            <></>
          ) : (
            <div className="nav__area">
              <div className="nav__no-user">
                <img src={emptyUserImg} alt="empty" />
              </div>
              <div
                className="nav__login"
                onClick={() => {
                  if (isMobile()) {
                    wxLogin();
                  } else {
                    setDialog("wx-login", true);
                  }
                }}
              >
                <p>登录</p>
                {/* <a href="/users/sign_in">登录</a> */}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Nav;
